<template>
    <section class="onboarding">
        <div class="onboarding__section">
            <header class="onboarding__header">
                <img src="/images/skybaseit-beta-inverse.svg" alt="skybase.it" class="onboarding__logo">
            </header>
            <div class="onboarding__body">
                <transition name="onboarding-item" mode="out-in">
                    <h1 :key="$route.meta.title" class="onboarding__title" v-html="$route.meta.title" />
                </transition>
                <transition name="onboarding-item" mode="out-in">
                    <img :key="$route.meta.title" :src="`/images/illustrations/${$route.meta.image}`" class="onboarding__illustration onboarding__illustration--mail" alt="Skybase - Stress Free Working"/>
                </transition>
            </div>
            <navigation :router="$router"/>
        </div>
        <div class="onboarding__section">
            <section class="onboarding__form">
                <transition name="onboarding-stage" mode="out-in">
                    <keep-alive>
                        <router-view :form="form" />
                    </keep-alive>
                </transition>
            </section>
        </div>
    </section>
</template>

<script>
import Navigation from './Navigation'
import Form from '../../helpers/Form'

export default {
    name: 'Create',

    props: {
        form: {
            type: Form,
            required: true
        }
    },

    components: {
        Navigation
    }
}
</script>
